import React, { Fragment } from "react"
import { useStaticQuery, graphql } from "gatsby"
import MenuLayout from "../layout/MenuLayout"
import MyChildren from "../layout/mychildren"

const BOBSWORLD = () => {
  const data = useStaticQuery(graphql`
    {
      internalResData(name: { eq: "Bobs World" }) {
        name
        items {
          name
          description
          price
          sizes {
            name
            price
          }
          groups {
            name
            options {
              name
              price
            }
          }
        }
        description
        id
      }
    }
  `)

  const { name, description, id, items } = data.internalResData

  return (
    <Fragment>
      <MenuLayout title={name} description={description}>
        {items.map(item => (
          <div key={id} className="items">
            <MyChildren
              id={id}
              name={item.name}
              description={item.description}
              price={item.price.toFixed(2)}
            />
            {item.sizes.length === 0 ? null : (
              <ul className="item-ul">
                <b>Sizes:</b>
                {item.sizes.map(size => (
                  <Fragment>
                    <li>
                      {size.name}{" "}
                      {size.price === 0 ? null : (
                        <span>- ${size.price.toFixed(2)}</span>
                      )}
                    </li>
                  </Fragment>
                ))}
              </ul>
            )}
            {item.groups.length === 0 ? null : (
              <div className="options">
                Options:{" "}
                {item.groups.map(group => (
                  <ul className="item-ul">
                    <span>
                      <b>Name: {group.name}</b>
                    </span>
                    {group.options.map(option => (
                      <li>
                        {option.name}
                        {option.price === 0 ? null : (
                          <Fragment> - ${option.price.toFixed(2)}</Fragment>
                        )}
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            )}
          </div>
        ))}
      </MenuLayout>
    </Fragment>
  )
}

export default BOBSWORLD
